//Imports
import React, { createContext, useState, useContext, useEffect } from 'react';

//Create Context
const CartContext = createContext();

//Export Context
export const useCart = () => useContext(CartContext);

//Cart Provider Component
export const CartProvider = ({ children }) => {
  //Cart State
  const [cartItems, setCartItems] = useState(() => {
    const saved = localStorage.getItem('cart');
    return saved ? JSON.parse(saved) : [];
  });

  //Cart Effect
  useEffect(() => {
    localStorage.setItem('cart', JSON.stringify(cartItems));
  }, [cartItems]);

  //Add to Cart Function
  const addToCart = (product) => {
    setCartItems(prev => {
      const existing = prev.find(item => item.id === product.id);
      if (existing) {
        return prev.map(item =>
          item.id === product.id ? { ...item, quantity: item.quantity + 1 } : item
        );
      }
      return [...prev, { ...product, quantity: 1 }];
    });
  };

  //Remove from Cart Function
  const removeFromCart = (productId) => {
    setCartItems(prev => prev.filter(item => item.id !== productId));
  };

  //Update Quantity Function
  const updateQuantity = (productId, amount) => {
    setCartItems(prev => prev.map(item => {
      if (item.id === productId) {
        const newQuantity = item.quantity + amount;
        return newQuantity > 0 ? { ...item, quantity: newQuantity } : item;
      }
      return item;
    }));
  };

  //Clear Cart Function
  const clearCart = () => setCartItems([]);

  //Cart Total Function
  const cartTotal = cartItems.reduce((total, item) => total + (item.price * item.quantity), 0);

  //Cart Count Function
  const cartCount = cartItems.reduce((count, item) => count + item.quantity, 0);

  //Return Cart Context
  return (
    <CartContext.Provider value={{
      cartItems,
      addToCart,
      removeFromCart,
      updateQuantity,
      clearCart,
      cartTotal,
      cartCount
    }}>
      {children}
    </CartContext.Provider>
  );
};
